import { render, staticRenderFns } from "./board_list.vue?vue&type=template&id=03c539d5&scoped=true&"
import script from "./board_list.vue?vue&type=script&lang=js&"
export * from "./board_list.vue?vue&type=script&lang=js&"
import style0 from "./board_list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./board_list.vue?vue&type=style&index=1&id=03c539d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c539d5",
  null
  
)

export default component.exports